<template>
    <div class="record_container">
        <div class="record_header" v-if="isPC">
            <h3 class="record_header_title">历史记录</h3>
            <span class="record_header_back" @click="$router.go(-1)">返回</span>
        </div>
        <NavBar title="历史记录" v-else/>
        <div class="recod_list_block">
            <div class="recod_list_item" v-for="(item, index) in datas" :key="index" @click="toItem(item.guid)">
                <div class="list_item_left">
                    <span class="list_item_title">关于{{ item.byComplaintPersonName }}的举报</span>
                    <span class="list_item_date">{{ item.createdStr }}</span>
                </div>
                <i class="el-icon-arrow-right list_item_arrow"></i>
            </div>
            <div class="record_empty" v-if="!datas || datas.length === 0">
                <i class="el-icon-document" style="font-size:48px;color:#c0c4cc;"></i>
                <span>暂无记录</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            loading:false,
            datas:[],
			isPC: window.innerWidth >= 769
        }
    },
    mounted(){
        document.title='历史记录'
        this.getDatas()
    },
    methods:{
        getDatas(){
            this.$http.get('/api/ts/v0.1/complaint/page')
            .then(res=>{
                console.log(res)
                if(res.status==200){
                    this.datas = res.data.list
                }else{
                    this.$message.error('查询失败！请联系管理员')
                }
                
                this.loading=false;
            })
            .catch((err)=>{
                this.loading=false;
            })
        },
        
        toItem(guid){
            this.$router.push({
                name: "info",
                query: {
                    guid:guid
                }
            });
        }
    }
}
</script>
<style scoped lang="less">
    .record_container{
        width: 100%;
        position: fixed;
        left: 0;
        top: 0;
        bottom: 0;
        background-color: #f2f2f2;
    }
    .record_header{
        width: 100%;
        height: 50px;
        background-color: white;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 16px;
        box-sizing: border-box;
        border-bottom: 1px solid #f2f2f2;
    }
    .record_header_title{
        margin: 0;
        font-size: 18px;
        font-weight: 600;
        color: #333;
    }
    .record_header_back{
        font-size: 14px;
        color: #44baff;
        cursor: pointer;
    }
    .recod_list_block{
        width: 100%;
        position: absolute;
        left: 0;
        top: 50px;
        bottom: 0;
        overflow-y: scroll;
        background-color: white;
    }
    .recod_list_item{
        width: 100%;
        height: 50px;
        border-bottom: 1px solid #f2f2f2;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 0 16px;
        box-sizing: border-box;
        cursor: pointer;
        &:active{
            background-color: #f2f2f2;
        }
    }
    .list_item_left{
        display: flex;
        flex-direction: row;
        align-items: center;
        flex: 1;
        min-width: 0;
    }
    .list_item_title{
        display: block;
        font-size: 16px;
        color: #333;
        font-weight: 700;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .list_item_date{
        display: block;
        font-size: 14px;
        color: #666;
        margin-left: 16px;
        flex-shrink: 0;
    }
    .list_item_arrow{
        color: #c0c4cc;
        font-size: 14px;
        margin-left: 8px;
    }
    .record_empty{
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 80px;
        color: #c0c4cc;
        font-size: 14px;
        span{
            margin-top: 12px;
        }
    }

    /* PC端响应式样式 */
    @media (min-width: 769px) {
        .record_container{
            width: 100%;
            height: 100%;
            background-color: #fff;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 40px 20px;
            box-sizing: border-box;
        }
        .record_header{
            width: 100%;
            height: auto;
            padding: 6px 20px;
            background: #fff;
            position: relative;
            margin-bottom: 10px;
            border: none;
            &::before {
                content: '';
                position: absolute;
                left: 0;
                top: 4px;
                bottom: 4px;
                width: 4px;
                background-color: #027cfb;
                border-radius: 0 6px 6px 0;
            }
        }
        .record_header_title{
            font-size: 22px;
            color: #333;
        }
        .record_header_back{
            font-size: 20px;
            color: #0169ff;
            cursor: pointer;
            &:hover{
                text-decoration: underline;
            }
        }
        .recod_list_block{
            width: 100%;
            height: 100%;
            position: initial;
            background-color: #fff;
            border-top: 1px solid #999;
            padding: 8px 0;
            overflow-y: auto;
            font-size: 18px;
        }
        .recod_list_item{
            height: auto;
            padding: 16px 24px;
            border-bottom: none;
            cursor: pointer;
            transition: background-color 0.15s;
            &:hover{
                background-color: #f5f7fa;
            }
        }
        .list_item_title{
            font-size: 18px;
            font-weight: 500;
        }
        .list_item_date{
            font-size: 18px;
            color: #999;
        }
        .list_item_arrow{
            color: #c0c4cc;
            font-size: 18px;
        }
        .record_empty{
            padding-top: 60px;
            padding-bottom: 40px;
            font-size: 18px;
        }
    }
</style>